import { useAppStore } from "@/app/store/app/store";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import {
        EnumEmploymentType,
        EnumDocumentationSendType,
        EnumPersonalDocumentType,
        EnumIdentificationType,
        EnumCollectionPointType,
        EnumPasswordStatus,
        EnumFlowType,
        EnumContractSending,
        IProduct,
        EnumContractSignatureType,
        EnumDiyType
    } from "nlb-buy-go-library";
import { IKeyValue } from "./store";
import { IFileData } from "fw4-library";

interface IContractCreateStore {
    ProcessData: IProcessData;
    CustomerData: ICustomerData;
    EmploymentData: IEmploymentData;
    ContractData: IContractData;
    CalculationData: ICalculationData;
    PreapprovedData: IPreapproved;
    ExposureData: IExposureData;
    IdentificationData: IIdentificationData;
    SisbonData: ISisbonData;
    HeaderData: IHeaderData;
    ContractSuccessData: IContractSuccess;
    AppNavButtons: IAppNavButton[];
};

export interface IAppNavButton {
    title: string;
    routerName?: string;
    runFunction?: (obj?: any) => void;
    class?: string;
    href?: any;
    img?: string;
    completed?: boolean;
};

interface ISisbonData {
    sisbonResultId: number;
    debtAmount: number;
    debtInstallments: number;
    minSalary: number;
    minCredit: number;
};

interface IContractSuccess {
    successText: string;
};

interface ICustomerData {
    prefix: IKeyValue | undefined;
    phoneNumber: number | null;
    email: string;
    isEmailVerified: boolean;
    taxNumber: number| null;
    firstname: string;
    surname: string;
    emso: string | null;
    address: string;
    postalCode: number | undefined;
    isMale: boolean;
    birthdate: Date | null;
    birthCity: string;
    citizen: number | undefined;
    hasTemporaryResidence: boolean | undefined;
    temporaryCitizen: number | undefined;
    temporaryPostalCode: string | undefined;
    temporaryForeignPostalCode: string;
    temporaryAddress: string;
    countrySourceFunds: string;
    countryFundsStatus: string;
    prefilledData?: boolean;
};

interface ICalculationData {
    calculationId: number;
    creditAmount: number | undefined;
    installmentNr: number;
    installmentVal: number;
    installmentValNoCost: number;
    lastMonthsIncome: number | undefined;
    lastMonthsIncome2: number | undefined;
    lastMonthsIncome3: number | undefined;
    isDocumentationNeeded: boolean;
    mustProvideThreeSalaries: boolean;
};

interface IProcessData {
    flowType: EnumFlowType | undefined;
    orderId: string;
    isAppDataLoading: boolean;
    isViewDataLoading: boolean;
    userFullName: string;
    notVehiculesFinancing: boolean;
    needsToChangePassword: boolean;
    isExistingUser: boolean;
    linkPasswordReset: string;
    linkParamsId: string;
    partnerDiyType: EnumDiyType | undefined;
    partnerId: number;
    partnerLimitsEOM: boolean;
    isCustomerContinuing: boolean;
};

interface IEmploymentData {
    employmentType: EnumEmploymentType | undefined;
    employerName: string;
    employerAddress: string;
    employerPostCode: string;
    isPoliticallyExposedPerson: boolean | undefined;
    politicalFunction: string;
    pioSourceFunds: string;
    pioFundsStatus: string;
};

interface IExposureData {
    minSalary: number;
    summitDebt: number;
    contractDebt: number;
    contractDebtInstallments: number;
    maxHitri: number | undefined;
    maxTriglavAmount: number | undefined;
};

interface IIdentificationData {
    isIdentified: boolean;
    personalDocumentType: EnumPersonalDocumentType | undefined;
    idNumber: string;
    idNumberCheck: string;
    documentIssuer: string;
    issueDate: Date | null;
    validityDate: Date | null;
    permanentValidity: Boolean | undefined;
    identificationConfirmation: Boolean | undefined;
    identificationPlace: EnumIdentificationType;
    identificationAddress: string;
    identificationPostalCode: number | undefined;
    collectionPoint: EnumCollectionPointType;
}

interface IContractData {
    hasPermanentResidenceInSlovenia : boolean | undefined;
    isSlovenianCitizen: boolean | undefined;
    hasSlovenianIncome: boolean | undefined;
    hasSlovenianBankAccount: boolean | undefined;

    creditAmount: number | undefined;
    pogodbaId: number;
    stPogodbe: string;
    triglavCode: string;

    documentationSendType: EnumDocumentationSendType | undefined;
    TRR: string;

    promoCode: string | undefined;

    deliveryType: EnumCollectionPointType | null;
    hasPersonalPickUp: boolean;
    hasHomeDelivery: boolean;
    code: string;
    selectedSpecialProduct: IProduct | undefined;
    selectedPromoProduct: IProduct | undefined;
    selectedProduct: IProduct | undefined;    
    selectedProductType: string | undefined;    
    documentNumber: string;
    willAttachDocumentation: boolean | undefined;
    bindingFiles: IFileData[];
    documentationFiles: IFileData[],
    termsAgreement: Boolean;
    isCompanyTaxNumber: boolean;
    productList: IProduct[];
    specialProductList: IProduct[];
    promoProductList: IProduct[];
    EOMInstallmentMax: number | undefined;
    //KONEC IDENTIFICATION DATA

    //ZAČETEK SKLENI SAM DATA
    file: IFileData[];

    //KONEC SKLENI SAM DATA
    dataConfirmation: boolean;
    //KONEC DATA CONFIRMATION PLACE DATA

    marketingSummit: boolean;
    marketingCreditBroker: boolean;

    //PASSWORD
    password: string;
    firstPassword: string;
    repeatPassword: string;
    status: EnumPasswordStatus;
    descriptionText: string;
    //KONEC PASSWORD
    //signature
    contractSignatureType: EnumContractSignatureType | undefined;
    contractSending: EnumContractSending | undefined;
    showEmploymentType: boolean;
}

interface IPreapproved {
    isPreapproved: boolean;
    preapprovedType: string;
    numberOfPreapprovedSalaries: number;
    preapprovedCreditAmount: number;
    preapprovedInstallmentAmount: number;
}

interface IDemoData {
    propText: string;
    propText123: string;
    propNumber: number;
}

interface IHeaderData {
    headerTitle: string;
    headerSubtitle: string;
    headerParameter: string;
    HTMLBody: string;
}

const defaultHeaderData: IHeaderData = {
    headerTitle: "",
    headerSubtitle: "",
    headerParameter: "",
    HTMLBody: ""
};

const defaultContractSuccess: IContractSuccess = {
    successText: ""
};

const defaultProcessData: IProcessData = {
    flowType: undefined,
    orderId: "",
    isAppDataLoading: false,
    isViewDataLoading: false,
    userFullName: "",
    notVehiculesFinancing: false,
    needsToChangePassword: false,
    isExistingUser: false,
    linkPasswordReset: 'Precheck',
    linkParamsId: ':1',
    partnerDiyType: undefined,
    partnerId: -1,
    partnerLimitsEOM: false,
    isCustomerContinuing: false,
}

const defaultEmploymentData: IEmploymentData = {
    employmentType: undefined,
    employerName: "",
    employerAddress: "",
    employerPostCode: "",
    isPoliticallyExposedPerson: undefined,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: "",
}

const defaultCustomerData: ICustomerData = {
    prefix: { Key: "386", Value: "SI +386" },
    phoneNumber: null,
    email: "",
    isEmailVerified: false,
    taxNumber: null,
    firstname: "",
    surname: "",
    emso:   null,
    address: "",
    postalCode: undefined,
    isMale: false,
    birthdate: null,
    birthCity: "",
    citizen: undefined,
    hasTemporaryResidence: undefined,
    temporaryCitizen: undefined,
    temporaryPostalCode: undefined,
    temporaryForeignPostalCode: "",
    temporaryAddress: "",
    countryFundsStatus: "",
    countrySourceFunds: "",
    prefilledData: false
}

const defaultIdentificationData: IIdentificationData = {
    isIdentified: false,
    personalDocumentType: undefined,
    idNumber: "",
    idNumberCheck: "",
    documentIssuer: "",
    issueDate: null,
    validityDate: null,
    permanentValidity: undefined,
    identificationConfirmation: false,
    identificationPlace: EnumIdentificationType.posta,
    collectionPoint: EnumCollectionPointType.dostava,
    identificationAddress: "",
    identificationPostalCode: undefined,
}

const defaultContractData: IContractData = {
    hasPermanentResidenceInSlovenia: undefined,
    isSlovenianCitizen: undefined,
    hasSlovenianIncome: undefined,
    hasSlovenianBankAccount: undefined,

    code: "",
    documentationSendType: undefined,

    TRR: "",

    deliveryType: null,
    hasPersonalPickUp: true,
    hasHomeDelivery: true,
    creditAmount: undefined,

    // employmentType: undefined,
    selectedSpecialProduct: undefined,
    selectedPromoProduct: undefined,
    selectedProduct: undefined,
    selectedProductType: undefined,
    EOMInstallmentMax: undefined,
    documentNumber: "",
    bindingFiles: [],
    willAttachDocumentation: undefined,
    documentationFiles: [],
    termsAgreement: false,
    isCompanyTaxNumber: false,
    file: [],
    productList: [],
    specialProductList: [],
    promoProductList: [],

    dataConfirmation: false,
    marketingSummit: false,
    marketingCreditBroker: false,

    password: "",
    firstPassword: "",
    repeatPassword: "",
    status: EnumPasswordStatus.Success,
    descriptionText: "Geslo je bilo uspešno zamenjano",
    contractSignatureType: undefined,
    contractSending: undefined,
    promoCode: "",
    triglavCode: "",
    pogodbaId: 0,
    stPogodbe: "",
    showEmploymentType: false,
}

const defaultCalculationData: ICalculationData = {
    calculationId: 0,
    creditAmount: undefined,
    installmentNr: 0,
    installmentVal: 0,
    installmentValNoCost: 0,
    lastMonthsIncome: undefined,
    lastMonthsIncome2: undefined,
    lastMonthsIncome3: undefined,
    mustProvideThreeSalaries: false,
    isDocumentationNeeded: false
}

const defaultPreapprovedData: IPreapproved = {
    isPreapproved: false,
    preapprovedType: "",
    numberOfPreapprovedSalaries: 0,
    preapprovedCreditAmount: 0,
    preapprovedInstallmentAmount: 0
}

const defaultExposureData: IExposureData = {
    minSalary: 0,
    summitDebt: 0,
    contractDebt: 0,
    contractDebtInstallments: 0,
    maxHitri: undefined,
    maxTriglavAmount: undefined
}

const defaultSisbonData: ISisbonData = {
    sisbonResultId: -1,
    debtAmount: 0,
    debtInstallments: 0,
    minSalary: 0,
    minCredit: 0
}

const defaultDemoData: IDemoData = {
    propText: "init from store",
    propText123: "init from store 123",
    propNumber: 3
}

export const useContractCreateStore = defineStore("contractCreateStore", () => {
    const AppState = ref<IContractCreateStore>({
        ProcessData: {
            ...defaultProcessData
        },
        CustomerData: {
            ...defaultCustomerData
        },
        EmploymentData: {
            ...defaultEmploymentData
        },
        ContractData: {
            ...defaultContractData
        },
        CalculationData: {
            ...defaultCalculationData
        },
        PreapprovedData: {
            ...defaultPreapprovedData
        },
        IdentificationData: {
            ...defaultIdentificationData
        },
        ExposureData: {
            ...defaultExposureData
        },
        SisbonData: {
            ...defaultSisbonData
        },
        HeaderData: {
            ...defaultHeaderData
        },
        ContractSuccessData: {
            ...defaultContractSuccess
        },
        AppNavButtons: [],
    });

    function reset() {
        AppState.value.ProcessData = { ...defaultProcessData }
        AppState.value.CustomerData = { ...defaultCustomerData }
        AppState.value.EmploymentData = { ...defaultEmploymentData }
        AppState.value.ContractData = { ...defaultContractData }
        AppState.value.CalculationData = { ...defaultCalculationData }
        AppState.value.PreapprovedData = { ...defaultPreapprovedData }
        AppState.value.IdentificationData = { ...defaultIdentificationData }
        AppState.value.ExposureData = { ...defaultExposureData }
        AppState.value.SisbonData = { ...defaultSisbonData }
        AppState.value.HeaderData = { ...defaultHeaderData }
        AppState.value.ContractSuccessData = { ...defaultContractSuccess }
    };

    async function EmailVerified(Message: any){
        if(Message && Message[0] && Message[0].CallbackType == "EMAIL_VERIFICATION" && Message[0].Success){
            AppState.value.CustomerData.isEmailVerified = true;
        }
    };

    const isPreapprovedValid = computed(() => {
        const appStore = useAppStore();
        
        return (
            AppState.value.PreapprovedData.isPreapproved === true
            && AppState.value.PreapprovedData.preapprovedCreditAmount >= AppState.value.ContractData.creditAmount!
            && AppState.value.PreapprovedData.preapprovedInstallmentAmount >= AppState.value.CalculationData.installmentValNoCost
            && (AppState.value.PreapprovedData.preapprovedType !== 'S1' || appStore.User.AvtoBroker === false) // hitri preapproved (S1) samo če ni avtobroker
        );
    });

    // const AppState = ref<IContractCreateStore>({
    //     ProcessData: {
    //         ...defaultProcessDataForTesting
    //     },
    //     CustomerData: {
    //         ...defaultCustomerDataForTesting
    //     },
    //     EmploymentData: {
    //         ...defaultEmploymentDataForTesting
    //     },
    //     ContractData: {
    //         ...defaultContractDataForTesting
    //     },
    //     CalculationData: {
    //         ...defaultCalculationDataForTesting
    //     },
    //     PreapprovedData: {
    //         ...defaultPreapprovedData
    //     },
    //     ExposureData: {
    //         ...defaultExposureData
    //     },
    //     DemoData: {
    //         ...defaultDemoData
    //     },
    // });

    // function reset() {
    //     AppState.value.ProcessData = { ...defaultProcessDataForTesting }
    //     AppState.value.CustomerData = { ...defaultCustomerDataForTesting }
    //     AppState.value.EmploymentData = { ...defaultEmploymentDataForTesting }
    //     AppState.value.ContractData = { ...defaultContractDataForTesting }
    //     AppState.value.CalculationData = { ...defaultCalculationDataForTesting }
    //     AppState.value.PreapprovedData = { ...defaultPreapprovedData }
    //     AppState.value.ExposureData = { ...defaultExposureData }
    //     AppState.value.DemoData = { ...defaultDemoData }
    // }
    
    return {
        AppState,
        reset,
        isPreapprovedValid,
        EmailVerified
    };
});


const defaultProcessDataForTesting: IProcessData = {
    flowType: "pos",
    orderId: "",
    isAppDataLoading: false,
    isViewDataLoading: false,
    userFullName: "",
    notVehiculesFinancing: false,
    needsToChangePassword: false,
    isExistingUser: false,
    linkPasswordReset: 'Precheck',
    linkParamsId: ':1',
    partnerDiyType: undefined,
    partnerId: -1,
    partnerLimitsEOM: false,
    isCustomerContinuing: false,
};

const defaultCalculationDataForTesting: ICalculationData = {
    calculationId: 763411,
    creditAmount: 1123,
    installmentNr: 15,
    installmentVal: 0,
    installmentValNoCost: 0,
    lastMonthsIncome: 1234,
    lastMonthsIncome2: 1234,
    lastMonthsIncome3: 1234,
    mustProvideThreeSalaries: false,
    isDocumentationNeeded: false
};

const defaultCustomerDataForTesting: ICustomerData = {
    prefix: {
        Key: "386",
        Value: "SI +386"
    },
    phoneNumber: 41795886,
    email: "simong@hgi.si",
    isEmailVerified: false,
    taxNumber: 18911331,
    firstname: "SIMON",
    surname: "TEST",
    emso:   "0806976500479",
    address: "Pot k studencu 12",
    postalCode: 1000,
    isMale: false,
    birthdate: null,
    birthCity: "Ljubljana",
    citizen: 204,
    hasTemporaryResidence: false,
    temporaryCitizen: undefined,
    temporaryPostalCode: undefined,
    temporaryForeignPostalCode: "",
    temporaryAddress: "",
    countryFundsStatus: "",
    countrySourceFunds: "",
};

const defaultEmploymentDataForTesting: IEmploymentData = {
    employmentType: EnumEmploymentType.Zaposlen,
    employerName: "",
    employerAddress: "",
    employerPostCode: "",
    isPoliticallyExposedPerson: false,
    politicalFunction: "",
    pioSourceFunds: "",
    pioFundsStatus: "",
}

const defaultIdentificationDataForTesting: IIdentificationData = {
    isIdentified: false,
    personalDocumentType: "OS",
    idNumber: "123456789",
    idNumberCheck: "",
    documentIssuer: "LJUBLJANA",
    issueDate: new Date(2020, 1, 1),
    validityDate: new Date(2030, 1, 1),
    permanentValidity: undefined,
    identificationConfirmation: false,
    identificationPlace: EnumIdentificationType.posta,
    collectionPoint: EnumCollectionPointType.dostava,
    identificationAddress: "",
    identificationPostalCode: undefined,
};

const defaultContractDataForTesting: IContractData = {
    hasPermanentResidenceInSlovenia: true,
    isSlovenianCitizen: true,
    hasSlovenianIncome: true,
    hasSlovenianBankAccount: true,

    documentationSendType: undefined,

    TRR: "051007041274011",

    deliveryType: null,
    hasPersonalPickUp: true,
    hasHomeDelivery: true,
    creditAmount: 1123,

    // employmentType: undefined,
    selectedSpecialProduct: undefined,
    selectedPromoProduct: undefined,
    selectedProductType: "OBR",
    selectedProduct: {
        productId: "OBR",
        productName: "Obrestni kredit",
        installmentMin: 3,
        installmentMax: 84,
        amountMin: 120,
        amountMax: 15000,
        ageMin: 18,
        ageMax: 80,
    },
    code: "",
    documentNumber: "123456789",
    bindingFiles: [],
    willAttachDocumentation: false,
    documentationFiles: [],
    termsAgreement: false,
    isCompanyTaxNumber: false,
    file: [],
    productList: [],
    specialProductList: [],
    promoProductList: [],
    EOMInstallmentMax: undefined,
    
    dataConfirmation: false,
    marketingSummit: false,
    marketingCreditBroker: false,

    password: "",
    firstPassword: "",
    repeatPassword: "",
    status: EnumPasswordStatus.Success,
    descriptionText: "Geslo je bilo uspešno zamenjano",
    contractSignatureType: undefined,
    contractSending: undefined,
    promoCode: "",
    triglavCode: "",
    pogodbaId: 0,
    stPogodbe: "",
    showEmploymentType: false,
}